module.exports = "/static-assets/_next/static/images/trophy-dceb7cb5f688c453c3275ea89f7331fd.png";